import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from './UserAvatarCircle.module.scss';

export type UserAvatarCircleProps = {
  firstName: string | null;
  lastName: string | null;
  imageUrl?: string | null;
  size?: number;
  className?: string;
};

const getInitials = (firstName?: string | null, lastName?: string | null) => {
  return `${firstName?.[0]}${lastName?.[0]}`.toUpperCase();
};

const UserAvatarCircle = ({ firstName, lastName, imageUrl, size = 48, className }: UserAvatarCircleProps) => {
  const initials = useMemo(() => getInitials(firstName, lastName), [firstName, lastName]);
  const fontSize = Math.max(12, Math.round(size / 3));

  const style: React.CSSProperties = { width: size, height: size, fontSize };

  return (
    <span className={cn(styles.root, className)} style={style} aria-hidden>
      {imageUrl ? <img className={styles.img} src={imageUrl} alt="avatar" /> : initials}
    </span>
  );
};

export default UserAvatarCircle;
